import { RootState } from '../rootReducer';

export const checkIsAreaExpanded = (state: RootState) => (id: number): boolean => state.areas.expanded.includes(id);
